export interface QuoteProgram {
    programName: string;
    programID?: number;
    accountID: number;
    coverageTypeId: number;
    coverageType: string;
    year: number;
    bound?: boolean;
    boundDatetime?: string;
    deleted?: boolean;
    insertedBy?: string;
    insertedDate?: string;
    programType: number;
    programTypeName?: string;
    currentProgramExpiration?: string;
    quotes?: Quote[];
}

export interface QuoteSequenceRequestItem {
    layerId: number;
    quoteId: number;
    quoteIndex: number;
}

export interface QuoteSequenceRequest {
    items: QuoteSequenceRequestItem[]
}

export interface Quote {
    programId: number;
    accountId: number;
    coverageType: string;
    layerName?: string;
    layerIndex?: number;
    layerId?: number;
    layerIdStr?: string;
    layerType?: string;
    quoteId?: number;
    quoteIndex: number;

    insurerGroupId?: number | null;
    insurerGroup?: string;
    issuingCompanyId?: number;
    issuingCompanyName?: string;

    wholesalerGroupId?: number | null;
    wholesalerGroup?: string;
    wholesalerId?: number | null;
    wholesaler?: string;

    bound?: boolean;
    admitted?: boolean;
    incumbent?: boolean;
    underwriter?: string;

    responseStatusId?: number;
    responseStatus?: string;
    responseDate?: string;
    declinedReasonId?: number;

    aggregateLimit?: number | null;
    surplusLinesTax?: number | null;
    quotashareTotal?: number | null;
    retention?: number | null;
    attachmentPoint?: number | null;
    premium?: number | null;
    commissionPercent?: number | null;

    quoteItems?: QuoteItem[];

    // computed on the front-end for display purposes

    lowest: boolean;
    declined: boolean;
    declinedReason?: string;
    displayKey?: number;
}

export interface QuoteItem {
    quoteItemId?: number;
    quoteItemTypeId: number;
    quoteId: number;
    value?: string;
}

export interface QuoteRefDataType {
    id: number;
    name: string;
}

export interface QuoteItemType {
    quoteItemTypeId: number;
    quoteItemLookupId: number;
    optionType: string;
    name: string;
    indexOrder: number;
    required: boolean;
    validatorRegex?: string | null,
    validatorMessage?: string | null
}

export interface QuoteLayer {
    layerIndex?: number;
    layerName?: string;
    layerId?: number;
    layerIdStr?: string;
    quotes: Array<Quote>;
    layerType?: string;
    deleted?: number;
}
export function calculateQuotePPM(quote: Quote): number | null {
    // PPM = (premium / limit) * 1,000,000
    if (quote.premium && quote.aggregateLimit) {
        return (quote.premium / quote.aggregateLimit) * 1000000;
    }
    return null;
}
